const {
  REACT_APP_API_ROOT,
  REACT_APP_SESSION_ROOT,
  REACT_APP_ENCRYPT_KEY_GAMES,
} = process.env;

export const APP_API_ROOT = REACT_APP_API_ROOT;
export const SESSION_API_ROOT = REACT_APP_SESSION_ROOT;
export const ENCRYPT_PASSWORD = REACT_APP_ENCRYPT_KEY_GAMES;
